export default __webpack_public_path__ + "static/media/succion de fosas2.d36c60f0.png";